import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { FormControl, InputLabel, TextField, Grid, Input,Divider, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import DatePicker from "material-ui-pickers/DatePicker";
import {
  curves,
  shocks,
  interestRateTypes,
  amortTypes,
  dayCountTypes,
  businessDayAdjustmentMethods,
  interestRateRounding
} from "../../Constants/DropDownLists";
import {
  CAP_VOLS,
  MARKET_EXPECTATIONS_SHOCK,  
  PARALLEL_SHOCK,
  STANDARD_DEVIATION_SHOCK
} from "../../Constants/Constants";
import {FIXED_RATE, FLOATING_RATE} from '../../Constants/InterestRateType';
import {INTEREST_ONLY, MORTGAGE_STYLE, STRAIGHT_LINE, STRAIGHT_LINE_CUSTOM_AMOUNT, AGENCY_FLOATER} from '../../Constants/AmortizationType';
import { StyledGrid, PrimaryButton } from "../../Constants/StyledComponents";
import DropDownFormControl from "../Components/DropDownFormControl";
import payment from './payment';
import inputComponentMask from "lib/inputMask";
import { AddCircleOutline, RemoveCircleOutline } from "@material-ui/icons";

const styles = {
  dropDownList: {
    width: "150px"
  }
};
let amortizationCurves = [...curves];
let index = amortizationCurves.findIndex(x => x.Name === "Cap Vols"); //cannot amortize based on cap vols
amortizationCurves.splice(index,1)

class AmortizationTestHarnessSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //always True
      shouldHide_loanAmount: false,
      shouldHide_startDate: false,
      shouldHide_loanTerm: false,
      shouldHide_daycount: false,
      shouldHide_interestRateType: false,

      shouldHide_amortizationType: false,

      // Only True if Floating
      shouldHide_curve: true,
      shouldHide_spread: true,
      shouldHide_shockType: true,
      shouldHide_shockValue: true,

      // Only True if Fixed
      shouldHide_rate: false,

      // amortizationType conditionals
      shouldHide_amortizationRate: true,
      shouldHide_amortizationTerm: true,
      shouldHide_customMonthlyPrincipalReduction: true,
      shouldHide_ioPeriod: true
    };
  }
  formatMoney = num => {
    return "$"+(
      new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num)
    );
  };

  shouldDisableShockValue() {
    return (
      this.props.state.curve !== CAP_VOLS &&
      this.props.state.shockType === MARKET_EXPECTATIONS_SHOCK
    );
  }

  shouldDisableShockScenario() {
    return this.props.state.curve === CAP_VOLS;
  }

  isFloatingSelected = () =>  this.props.state.interestRateType === FLOATING_RATE;
  
  isFixedSelected = () => this.props.state.interestRateType === FIXED_RATE;
  transformNumber = val => {
    if(!val)
      return 0;
    return +val.replace(/[^0-9.-]+/g, "");
  }

  calculatePayment = () => {    
    const amortType = this.props.state.amortizationType;
    const placeholder = "N/A";
    switch(amortType){
      default:
      case INTEREST_ONLY:
        return placeholder;        
      case MORTGAGE_STYLE:
        return this.formatMoney(
          payment(
            this.transformNumber(this.props.state.amortizationRate)/(12 * 100), 
            this.props.state.amortizationTerm,
            -this.transformNumber(this.props.state.loanAmount)));        
      case STRAIGHT_LINE:
        return placeholder;
      case STRAIGHT_LINE_CUSTOM_AMOUNT:
        return placeholder;
      case AGENCY_FLOATER:
        return placeholder
    }    
  }
  calculatePrincipalReduction = () => {
    const amortType = this.props.state.amortizationType;
    const placeholder = "N/A";
    if(this.props.state.amortizationTerm === 0)
      return placeholder;
    switch(amortType){
      case INTEREST_ONLY:
        return 0;
      case MORTGAGE_STYLE:
        return placeholder;
      case STRAIGHT_LINE:
        return this.formatMoney(this.transformNumber(this.props.state.loanAmount) / this.transformNumber(this.props.state.amortizationTerm));
      case STRAIGHT_LINE_CUSTOM_AMOUNT:
        return this.formatMoney(this.transformNumber(this.props.state.customMonthlyPrincipalReduction));
      case AGENCY_FLOATER:
        return placeholder;
    }    
  }
  handleInterestRateTypeChange = () => {    
    this.setState({            
      //Only True if Floating
      shouldHide_curve: this.isFloatingSelected(),
      shouldHide_spread: this.isFloatingSelected(),
      shouldHide_shockType: this.isFloatingSelected(),
      shouldHide_shockValue:this.isFloatingSelected(),
      //Only True if Fixed
      shouldHide_rate: this.isFixedSelected()
    });
    this.props.handleChange({target: { name: "interestRate", value: null }});
  };
  shouldHideAmortizationRate = () => {
    const amortizationType = this.props.state.amortizationType;
    const interestRateType = this.props.state.interestRateType;
    return amortizationType === INTEREST_ONLY ||
    amortizationType === STRAIGHT_LINE ||
    amortizationType === STRAIGHT_LINE_CUSTOM_AMOUNT ||
    amortizationType === AGENCY_FLOATER || 
    (interestRateType === FIXED_RATE && amortizationType === MORTGAGE_STYLE);
  }
  shouldHideAmortizationTerm = () => {
    const amortizationType = this.props.state.amortizationType;
    return amortizationType === INTEREST_ONLY ||
    amortizationType === STRAIGHT_LINE_CUSTOM_AMOUNT;
  }
  shouldHideCustomMonthlyPrincipalReduction = () => {
    const amortizationType = this.props.state.amortizationType;
    return amortizationType === INTEREST_ONLY ||
        amortizationType === STRAIGHT_LINE ||
        amortizationType === MORTGAGE_STYLE ||
        amortizationType === AGENCY_FLOATER;
  }
  shouldHideIoPeriod = () => {
    const amortizationType = this.props.state.amortizationType;
    return amortizationType === INTEREST_ONLY;
  }
  getShockValueLabel(shockType){
    if(shockType === PARALLEL_SHOCK)
      return  "Parallel Shift Amt (bp)";
    if(shockType === STANDARD_DEVIATION_SHOCK)
      return "Standard Deviations";
  }
  render() {    
    const { classes } = this.props;
    const {shockType} = this.props.state;

    if (!this.props.state) 
      return null;

    const shouldHideFloatingRateInputs = !this.isFloatingSelected();
    const shouldHideFixedRateInputs = !this.isFixedSelected();
    const shouldHide_amortizationRate = this.shouldHideAmortizationRate();
    const shouldHide_amortizationTerm = this.shouldHideAmortizationTerm();
    const shouldHide_customMonthlyPrincipalReduction = this.shouldHideCustomMonthlyPrincipalReduction();
    const shouldHide_ioPeriod = this.shouldHideIoPeriod();
    return (
      <Grid
        container
        spacing={8}
        alignItems="flex-start"
        justify="flex-start"
        direction="row"
      >
        {/* Row 1 */}
        <StyledGrid item xs={3} hidden={this.state.shouldHide_loanAmount}>
        
          <FormControl className="selectMenu">
            <InputLabel htmlFor="loanAmount">Loan Amount</InputLabel>
            <Input
              type="text"
              name="loanAmount"
              value={this.props.state.loanAmount}
              onChange={this.props.handleChange}                            
              inputComponent={inputComponentMask({
                  mask: "currencynocents"                  
                })}
            />
          </FormControl>
        </StyledGrid>
        <StyledGrid item xs={3} hidden={this.state.shouldHide_startDate}>
          <FormControl className="selectMenu">
            <DatePicker
              label="Start Date"
              name="startDate"
              format="MM/DD/YYYY"
              value={this.props.state.startDate}
              onChange={value =>
                this.props.handleChange({
                  target: { name: "startDate", value }
                })
              }
            />
          </FormControl>
        </StyledGrid>
        <StyledGrid item xs={3} hidden={this.state.shouldHide_loanTerm}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="loanTerm">Loan Term (m)</InputLabel>
            <Input
              type="text"
              name="loanTerm"
              value={this.props.state.loanTerm}
              onChange={this.props.handleChange}
            />
          </FormControl>
        </StyledGrid>
        <StyledGrid item xs={3} hidden={this.state.shouldHide_daycount}>
          <DropDownFormControl
            htmlFor="daycount"
            labelName="Daycount"
            value={this.props.state.dayCount}
            onChange={this.props.handleChange}
            inputProps={{ name: "dayCount" }}
            menuItemList={dayCountTypes}
          />
        </StyledGrid>

        <StyledGrid item xs={12}>
          <Divider/>
        </StyledGrid>
        <StyledGrid item xs={12}>
        <b>Interest Rates</b></StyledGrid>
        
        {/* Row 2 */}
        <StyledGrid
          item
          xs={12}
          hidden={this.state.shouldHide_interestRateType}
        >
          <DropDownFormControl
            className={classes.list}
            htmlFor="interestRateType"
            labelName="Interest Rate Type"
            value={this.props.state.interestRateType || ""}
            onChange={target => {
              this.props.handleChange(target);
              this.handleInterestRateTypeChange();
            }}
            inputProps={{ name: "interestRateType" }}
            menuItemList={interestRateTypes}
          />
        </StyledGrid>

        {/* Row 4 - Fixed*/}
        <StyledGrid item xs={12} hidden={shouldHideFixedRateInputs}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="interestRate">Rate (%)</InputLabel>
            <Input
              type="text"
              name="interestRate"
              value={this.props.state.interestRate ?? ""}
              onChange={this.props.handleChange}
              inputComponent={inputComponentMask({
                mask: "percent"
              })}
            />
          </FormControl>
        </StyledGrid>

        {/* Row 4 - Floating*/}
        <StyledGrid item xs={3} hidden={shouldHideFloatingRateInputs}>
          <DropDownFormControl
            htmlFor="curve"
            labelName="Benchmark/Index"
            value={this.props.state ? this.props.state.curve : ""}
            onChange={this.props.handleChange}
            inputProps={{ name: "curve" }}
            menuItemList={amortizationCurves}
          />
        </StyledGrid>
        <StyledGrid item xs={3} hidden={shouldHideFloatingRateInputs}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="spread">Spread (bps)</InputLabel>
            <Input
              type="text"
              name="spread"
              value={this.props.state.spread}
              onChange={this.props.handleChange}
            />
          </FormControl>
        </StyledGrid>
        <StyledGrid item xs={3} hidden={shouldHideFloatingRateInputs}>
          <DropDownFormControl
            htmlFor="shockScenario"
            labelName="Shock Scenario"
            value={shockType}
            onChange={this.props.handleChange}
            inputProps={{ name: "shockType" }}
            menuItemList={shocks}
            disabled={this.shouldDisableShockScenario()}
          />
        </StyledGrid>
        <StyledGrid item xs={3} hidden={shouldHideFloatingRateInputs}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="shockValue">
              {this.getShockValueLabel(shockType)}
            </InputLabel>
            <Input
              type="text"
              name="shockValue"
              value={this.props.state.shockValue}
              onChange={this.props.handleChange}
              disabled={this.shouldDisableShockValue()}
            />
          </FormControl>
        </StyledGrid>


        <StyledGrid item xs={3} hidden={shouldHideFloatingRateInputs}>
          <DropDownFormControl
            htmlFor="businessDayAdjustmentMethod"
            labelName="Payment Day Adjustment"
            value={this.props.state ? this.props.state.businessDayAdjustmentMethod : ""}
            onChange={this.props.handleChange}
            inputProps={{ name: "businessDayAdjustmentMethod" }}
            menuItemList={businessDayAdjustmentMethods}
          />
        </StyledGrid>

        <StyledGrid item xs={3} hidden={shouldHideFloatingRateInputs}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="lookbackDays">
              Lookback Days
            </InputLabel>
            <Input
              type="text"
              name="lookbackDays"
              value={this.props.state.lookbackDays}
              onChange={this.props.handleChange}              
            />
          </FormControl>
        </StyledGrid>

        <StyledGrid item xs={3} hidden={shouldHideFloatingRateInputs}>
          <DropDownFormControl
            htmlFor="interestRateRounding"
            labelName="Payment Day Adjustment"
            value={this.props.state ? this.props.state.interestRateRounding : ""}
            onChange={this.props.handleChange}
            inputProps={{ name: "interestRateRounding" }}
            menuItemList={interestRateRounding}
          />
        </StyledGrid>
        
        <StyledGrid item xs={3} hidden={shouldHideFloatingRateInputs}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="embeddedCap">
              Embedded Cap %
            </InputLabel>
            <Input
              type="text"
              name="embeddedCap"              
              value={this.props.state.embeddedCap || ""}
              onChange={this.props.handleChange}
              inputComponent={inputComponentMask({
                mask: "percent"
              })}
            />
          </FormControl>
        </StyledGrid>
                
        <StyledGrid item xs={3} hidden={shouldHideFloatingRateInputs}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="embeddedFloor">
              Embedded Floor %
            </InputLabel>
            <Input
              type="text"
              name="embeddedFloor"              
              value={this.props.state.embeddedFloor || ""}
              onChange={this.props.handleChange}
              inputComponent={inputComponentMask({
                mask: "percent"
              })}
            />
          </FormControl>
        </StyledGrid>

        <StyledGrid item xs={12}>
          <Divider/>
        </StyledGrid>
        <StyledGrid item xs={12}><b>Amortization</b></StyledGrid>
        {/* Row 5*/}
        <StyledGrid
          item
          xs={12}
          hidden={this.state.shouldHide_amortizationType}
        >
          <DropDownFormControl
            width='300px'
            htmlFor="amortizationType"
            labelName="Amortization Type"
            value={this.props.state.amortizationType}
            onChange={target => {
              this.props.handleChange(target);              
            }}
            inputProps={{ name: "amortizationType" }}
            menuItemList={amortTypes}
          />
        </StyledGrid>

        {/* Row 6*/}

        <StyledGrid item xs={3} hidden={shouldHide_amortizationRate}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="amortizationRate">
              Amortization Rate %
            </InputLabel>
            <Input
              type="text"
              name="amortizationRate"              
              value={this.props.state.amortizationRate || ""}
              onChange={this.props.handleChange}
              inputComponent={inputComponentMask({
                mask: "percent"
              })}
            />
          </FormControl>
        </StyledGrid>
        <StyledGrid item xs={3} hidden={shouldHide_amortizationTerm}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="amortizationTerm">
              Amortization Term
            </InputLabel>
            <Input
              type="text"
              name="amortizationTerm"
              value={this.props.state.amortizationTerm}
              onChange={this.props.handleChange}
            />
          </FormControl>
        </StyledGrid>
        <StyledGrid
          item
          xs={5}          
          hidden={shouldHide_customMonthlyPrincipalReduction}
        >
        <TextField
          fullWidth
          id="customMonthlyPrincipalReduction"
          name="customMonthlyPrincipalReduction"
          value= {this.props.state.customMonthlyPrincipalReduction}
          label="Custom Monthly Principal Reduction"
          onChange={this.props.handleChange}
        />
        </StyledGrid>
        
        <StyledGrid item xs={3} hidden={shouldHide_ioPeriod}>
          <FormControl className="selectMenu">
            <InputLabel htmlFor="interestOnlyPeriod">I/O Period (m)</InputLabel>
            <Input
              type="text"
              name="interestOnlyPeriod"
              value={this.props.state.interestOnlyPeriod}
              onChange={this.props.handleChange}
            />
          </FormControl>
        </StyledGrid>
        
        <StyledGrid item xs={12}>
        <Divider/>
        </StyledGrid>
        <StyledGrid item xs={12}><b>Partial Payments</b><Button onClick={this.props.addPartialPayment}><AddCircleOutline/></Button></StyledGrid>

        <StyledGrid container item xs={12} >
              {!this.props.state.partialPayments || this.props.state.partialPayments.length === 0 ? [] : this.props.state.partialPayments.map(pp => {
                return (<Grid key={`${pp.id}`} container item xs={12}>
                          <Grid key={`paymentDateGrid-${pp.id}`} item xs={5}>
                              <DatePicker key={`paymentDateDatePicker-${pp.id}`} 
                                          label="Payment Date" 
                                          name={`${pp.id}-date`} 
                                          format="MM/DD/YYYY" 
                                          value={pp.date} 
                                          onChange={(value) => this.props.handlePartialPaymentChange(pp.id, "date", value)} 
                                          />
                          </Grid>
                          <Grid key={`partialPaymentAmountGrid-${pp.id}`} item xs={5}>
                            <FormControl key={`partialPaymentAmountFormControl-${pp.id}`} className="selectMenu">
                              <InputLabel key={`partialPaymentAmountInputLabel-${pp.id}`} htmlFor="partialPaymentAmount">Amount</InputLabel>
                              <Input key={`partialPaymentAmountInput-${pp.id}`}
                                type="text"
                                name="partialPaymentAmount"
                                value={pp.amount || ""}
                                onChange={ (event) => this.props.handlePartialPaymentChange(pp.id, "amount", event.target.value)}
                                inputComponent={inputComponentMask({
                                  mask: "currency"
                                })}
                                />
                              </FormControl>
                          </Grid>
                          <Grid key={`removePartialPaymentGrid-${pp.id}`} item xs={2}>
                            <Button key={`removePartialPaymentButton-${pp.id}`} onClick={() => this.props.removePartialPayment(pp.id)}><RemoveCircleOutline/></Button>
                          </Grid>
                    </Grid>)})}
        </StyledGrid>


        <StyledGrid item xs={12}>
        <Divider/>
        </StyledGrid>
        <StyledGrid item xs={1}>
          <PrimaryButton
            variant="outlined"
            onClick={this.props.submit}
            className="downloadBtn"
          >
            Submit
          </PrimaryButton>
        </StyledGrid>
        <StyledGrid item xs={2}>
          <PrimaryButton
            variant="outlined"
            onClick={this.props.downloadTestData}
            className="downloadBtn"
          >
            Download
          </PrimaryButton>
        </StyledGrid>
        
        <StyledGrid item xs={12}><b>Calculated Values</b></StyledGrid>
        <Grid item xs={12}>
            <div>Payment: {this.calculatePayment()}</div>
          </Grid>
          <Grid item xs={12}>
            <div>Principal Reduction: {this.calculatePrincipalReduction()}</div>
          </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  authentication
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(AmortizationTestHarnessSearch);
